import { render, staticRenderFns } from "./DetailHero.vue?vue&type=template&id=9aea9698&"
import script from "./DetailHero.vue?vue&type=script&lang=js&"
export * from "./DetailHero.vue?vue&type=script&lang=js&"
import style0 from "./DetailHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports